import React, { useState } from 'react';
import {
  Box,
  Typography,
  TextField,
  Grid,
  Button,
  Container,
  FormControl,
  FormLabel,
  RadioGroup,
  Radio
} from '@mui/material';
// import MultipleSelectChip from '../../components/mutiselect1';
import { useDispatch, useSelector } from 'react-redux';
import { Autocomplete } from '@mui/material';
//import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
//import CheckBoxIcon from '@mui/icons-material/CheckBox';
import { useFormik } from 'formik';
import { validateInsuranceInfoForm } from './ValidateInsuranceInfoForm';
import { KeyboardArrowLeft } from '@mui/icons-material';
// import { useParams } from 'react-router-dom';
import * as caseActions from '../../../actions/caseActions';
////import * as patientActions from '../../../actions/patientActions';
//import * as loginActions from '../../../actions/loginActions';
import styles from '../dashboardstyles';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { useNavigate } from 'react-router-dom';
//import { INSURANCETYPE } from '../../../config/picklist';
//import * as Constants from '../../../config/constants';
//import { useSnackbar } from 'notistack';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
//const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
//const checkedIcon = <CheckBoxIcon fontSize="small" />;
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import FormControlLabel from '@mui/material/FormControlLabel';
//import { FileUploader } from 'react-drag-drop-files';
import Divider from '@mui/material/Divider';
import Tooltip from '@mui/material/Tooltip';
import onMobile from '../../../utils/onMobile';
import { GENDER } from '../../../config/gender';
import { countries } from '../../../config/country';
import { US_STATES_SORT_BY_NAME } from '../../../config/USStates';
import { DropzoneArea } from 'mui-file-dropzone';
import IconButton from '@mui/material/IconButton';
import DeleteIcon from '@mui/icons-material/Delete';
import AddIcon from '@mui/icons-material/Add';

//import { ReactComponent as InsuranceFront } from '../../../images/insuranceCardFront.png';

//const fileTypes = ['BMP', 'JPEG', 'JPG', 'PNG', 'GIF', 'TIF', 'TIFF'];

const InsuranceInfo = () => {
  // let { caseId } = useParams();
  // var caseId = props !== undefined && props.caseId !== undefined ? props.caseId : 0;
  // console.log(caseId);
  // redux
  // const dispatch = useDispatch();
  const st = useSelector((state) => state.rootReducer);
  const dispatch = useDispatch();
  //const [saveSubmitted, setSaveSubmitted] = useState(false);
  //const { enqueueSnackbar } = useSnackbar();
  /*useEffect(() => {
    // callback from other callers outside this component
    if (st.saveContactInfo) {
      //submitCaseContactInfo(formik.values);
      dispatch(caseActions.setSaveContactInfo(false));
    }
    //banner success message
    if (saveSubmitted && !st.isUpdateCaseLoading && st.updatecontacterror === '') {
      enqueueSnackbar(Constants.UPDATE_CASE_SUCCESS, {
        variant: 'success'
      });
      setSaveSubmitted(false);
    }
  }, [st.saveContactInfo, st.isUpdateCaseLoading, saveSubmitted, st.updatecontacterror]);
*/
  // control navigation target when leave the page
  // const [fromMenu, setFromMenu] = useState(false);
  // flag to see if the page data changed or not
  // const [dataUpdated, setDataUpdated] = useState(false);
  const [showDialog, setShowDialog] = useState(false);
  const dateToString = (dt) => {
    // Parse date without timezone
    if (dt === null) {
      dt = new Date();
    }
    var date_to_convert = new Date(
      dt.getUTCFullYear(),
      dt.getUTCMonth(),
      dt.getUTCDate(),
      10,
      0,
      0,
      0
    );
    return date_to_convert.toDateString().slice(4);
  };
  // step 4
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      financetype: st !== undefined ? st.patient.addressline1 : '',
      subscriberid: '',
      subscriberdob: ''
    },
    validationSchema: validateInsuranceInfoForm,
    onSubmit: () => {
      // alert('Submit UpdateAddress API\n' + JSON.stringify(values, null, 2));
      //submitCaseContactInfo(values);
      // reset flag
      //dispatch(caseActions.setDataUpdated(false));
      //setSaveSubmitted(true);
      // reset fromMenu
      // setFromMenu(false);
    }
  });

  let navigate = useNavigate();
  const handleHome = () => {
    if (st.caseId === null || st.caseId === 0 || st.caseId === undefined) {
      navigate('/sop2web/home');
      // reset flag before navigation
      dispatch(caseActions.setDataUpdated(false));
    } else {
      if (st.dataUpdated) {
        setShowDialog(true);
      } else {
        // reset flag before navigation
        dispatch(caseActions.setDataUpdated(false));
        dispatch(caseActions.setViewSummary(true));
      }
    }
    // reset error when navigate out
    //if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  const handleCancel = (event, reason) => {
    if (reason && reason == 'backdropClick') return;
    setShowDialog(false);
    dispatch(caseActions.setViewSummary(true));
    //reset change flag
    dispatch(caseActions.setDataUpdated(false));
    // reset fromMenu
    // setFromMenu(false);
    // reset error when navigate out
    //if (st.updatecontacterror !== '') dispatch(loginActions.clearError());
  };
  //const [file, setFile] = useState(null);
  /*const handleFileUploadChange = (file) => {
    setFile(file);
    // call API
  };
  const handleSizeError = (error) => {
    console.log(error);
    // call API
  };*/
  return (
    <Box>
      <Container>
        <Box
          sx={{
            mt: 3,
            display: 'flex',
            flexDirection: 'row',
            adjustItems: 'center',
            border: 0,
            justifyContent: 'space-between'
          }}>
          <Typography variant="h6">
            {/* Case Info for{' '} */}
            {st !== undefined && st.patient.firstName !== undefined && st.patient.lastName},
            {st !== undefined && st.patient.lastName !== undefined && st.patient.firstName}
            (MRN: {st !== undefined && st.patient.mrn !== undefined ? st.patient.mrn : 'N/A'}){' '}
          </Typography>
        </Box>
        <Box sx={{ mt: 2, mb: 2, padding: 1, backgroundColor: '#EDF3FC', boxShadow: 0 }}>
          <Box
            sx={{
              mx: 1,
              mt: 1,
              mb: 1
            }}>
            <Typography
              style={{
                color: '#021D4E',
                fontWeight: '500',
                fontSize: 18,
                mt: 0,
                mb: 2
                // textAlign: 'center'
              }}>
              Second Opinion is free of charge. However if we have guarantor and insurance
              information on file, it will significantly speed up your request process
            </Typography>
          </Box>
        </Box>
        <Grid container spacing={2}>
          <Grid
            container
            item
            xs={12}
            md={12}
            lg={12}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Tooltip title="The guarantor is the person finacially responsible for bill payment.">
              <Divider sx={{ color: '#021D4E', width: 900, mt: 4 }}>Guarantor Information</Divider>
            </Tooltip>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <Typography
                style={{
                  color: '#021D4E',
                  fontWeight: '800',
                  fontSize: 12,
                  mt: 0,
                  mb: 2
                  // textAlign: 'center'
                }}>
                The guarantor is the person finacially responsible for bill payment
              </Typography>
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                border: 0,
                mt: 0
              }}>
              <Box sx={{ mb: 2, ml: 2, mt: 2.5, mr: 2 }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '500',
                    fontSize: 16,
                    textAlign: 'left'
                  }}>
                  Are you Guarantor?
                </Typography>
              </Box>
              <Box sx={{ ml: 2, mt: 1 }}>
                <FormControl>
                  <FormLabel id="guarantor-group"></FormLabel>
                  <RadioGroup
                    row
                    aria-labelledby="guarantor"
                    name="isguarantor"
                    value={formik.values.guarantor}
                    onChange={(e) => {
                      formik.handleChange(e);
                      dispatch(caseActions.setDataUpdated(true));
                    }}>
                    <FormControlLabel
                      value="true"
                      control={<Radio />}
                      label={
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 15,
                            textAlign: 'left'
                          }}>
                          Yes
                        </Typography>
                      }
                    />
                    <FormControlLabel
                      value="false"
                      control={<Radio />}
                      label={
                        <Typography
                          style={{
                            color: '#021D4E',
                            fontWeight: '500',
                            fontSize: 15,
                            textAlign: 'left'
                          }}>
                          No
                        </Typography>
                      }
                    />
                  </RadioGroup>
                </FormControl>
              </Box>
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                //alignItems: 'center',
                //justifyContent: 'center',
                border: 0,
                mt: 0,
                width: 400
              }}>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="guarantorFirstName"
                label="First name"
                name="guarantorFirstName"
                autoComplete="guarantorFirstName"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                autoFocus
                value={formik.values.guarantorFirstName}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={
                  formik.touched.guarantorFirstName && Boolean(formik.errors.guarantorFirstName)
                }
                helperText={formik.touched.guarantorFirstName && formik.errors.guarantorFirstName}
              />
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="guarantorLastName"
                label="Last name"
                name="guarantorLastName"
                autoComplete="guarantorLastName"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                autoFocus
                value={formik.values.guarantorLastName}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.guarantorLastName && Boolean(formik.errors.guarantorLastName)}
                helperText={formik.touched.guarantorLastName && formik.errors.guarantorLastName}
              />
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                {!onMobile && (
                  <DatePicker
                    floatingLabelText="Date"
                    label="Date of birth"
                    size="small"
                    id="dob"
                    maxDate={new Date()}
                    // views={['year', 'month', 'date']}
                    // openTo="year"
                    value={formik.values.dob}
                    // disableFuture
                    // inputFormat="MM.dd.yyyy"
                    // mask="__.__.____"
                    // disableFuture
                    // showTodayButton
                    // onChange={formikAboutYou.handleChange}
                    onChange={(value) => {
                      formik.setFieldValue('dob', dateToString(value));
                      dispatch(caseActions.setDataUpdated(true));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        fullWidth
                        name="dob"
                        inputProps={{ style: { fontSize: 16 } }}
                        InputLabelProps={{ style: { fontSize: 14 } }}
                        value={formik.values.dob}
                        onChange={(value) => {
                          formik.setFieldValue('dob', dateToString(value));
                          dispatch(caseActions.setDataUpdated(true));
                        }}
                        error={formik.touched.dob && Boolean(formik.errors.dob)}
                        helperText={formik.touched.dob && formik.errors.dob}
                      />
                    )}
                  />
                )}
                {onMobile && (
                  <DatePicker
                    views={['day']}
                    label="Date of birth"
                    maxDate={new Date()}
                    value={formik.values.dob}
                    onChange={(newValue) => {
                      formik.setFieldValue('dob', newValue);
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        required
                        size="small"
                        variant="standard"
                        margin="dense"
                        fullWidth
                        helperText={'mm/dd/yyyy'}
                      />
                    )}
                  />
                )}
              </LocalizationProvider>
              <FormControl>
                <FormLabel id="gender-group">
                  <Typography
                    style={{
                      color: '#021D4E',
                      fontWeight: '500',
                      fontSize: 15,
                      textAlign: 'left'
                    }}>
                    Gender&#x2a;
                  </Typography>
                </FormLabel>
                <RadioGroup
                  row
                  aria-labelledby="gender"
                  name="gender"
                  id="gender"
                  value={formik.values.gender}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}>
                  {GENDER.map((res) => {
                    return (
                      <Box key={res.key}>
                        <FormControlLabel
                          value={res.value}
                          control={<Radio />}
                          label={
                            <Typography
                              style={{
                                color: '#021D4E',
                                fontWeight: '500',
                                fontSize: 15,
                                textAlign: 'left'
                              }}>
                              {res.text}
                            </Typography>
                          }
                        />
                      </Box>
                    );
                  })}
                </RadioGroup>

                {formik.touched.gender && Boolean(formik.errors.gender) && (
                  <Typography style={styles.errorText}>{formik.errors.gender}</Typography>
                )}
              </FormControl>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="guarantorRelationship"
                label="Relationship to patient"
                name="guarantorRelationship"
                autoComplete="guarantorRelationship"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                autoFocus
                value={formik.values.guarantorRelationship}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={
                  formik.touched.guarantorRelationship &&
                  Boolean(formik.errors.guarantorRelationship)
                }
                helperText={
                  formik.touched.guarantorRelationship && formik.errors.guarantorRelationship
                }
              />
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                border: 0,
                mt: 0,
                width: 400
              }}>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                autoFocus
                id="city"
                label="City"
                name="city"
                autoComplete="city"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.city || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.city && Boolean(formik.errors.city)}
                helperText={formik.touched.city && formik.errors.city}
              />
              {formik.values.country !== 'United States' && (
                <TextField
                  size="small"
                  variant="standard"
                  margin="dense"
                  fullWidth
                  label="Province"
                  name="province"
                  inputProps={{ style: { fontSize: 16 } }}
                  InputLabelProps={{ style: { fontSize: 14 } }}
                  value={formik.values.province}
                  onChange={(e) => {
                    formik.handleChange(e);
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                  error={formik.touched.province && Boolean(formik.errors.province)}
                  helperText={formik.touched.province && formik.errors.province}
                />
              )}
              {formik.values.country === 'United States' && (
                <Autocomplete
                  id="state"
                  sx={{ width: 400 }}
                  options={US_STATES_SORT_BY_NAME}
                  autoHighlight
                  getOptionLabel={(option) => {
                    console.log(option);
                    return option.text !== undefined
                      ? option.text
                      : option !== undefined
                      ? option
                      : '';
                  }}
                  renderOption={(props, option) => (
                    <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                      {option.text}
                    </Box>
                  )}
                  renderInput={(params) => (
                    <Box>
                      <TextField
                        {...params}
                        label="State"
                        size="small"
                        // variant="standard"
                        margin="dense"
                        fullWidth
                        name="state"
                        inputProps={{
                          ...params.inputProps,
                          style: { fontSize: 16 }
                        }}
                        InputLabelProps={{
                          style: { fontSize: 14 }
                        }}
                      />
                    </Box>
                  )}
                  value={formik.values.state}
                  isOptionEqualToValue={(option, value) => option.text === value}
                  onChange={(e, value) => {
                    console.log(value);
                    formik.setFieldValue('state', value !== null ? value.text : '');
                    dispatch(caseActions.setDataUpdated(true));
                  }}
                />
              )}
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="zip"
                label="Zip code"
                name="zip"
                autoComplete="zip"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                value={formik.values.zip || ''}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.zip && Boolean(formik.errors.zip)}
                helperText={formik.touched.zip && formik.errors.zip}
              />
              <Autocomplete
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="country"
                label="Primary country of residence"
                sx={{ width: 400 }}
                options={countries}
                autoHighlight
                getOptionLabel={(option) => {
                  console.log(option);
                  return option.label !== undefined
                    ? option.label
                    : option !== undefined
                    ? option
                    : 'United States';
                }}
                renderOption={(props, option) => (
                  <Box component="li" sx={{ '& > img': { mr: 2, flexShrink: 0 } }} {...props}>
                    <img
                      loading="lazy"
                      width="20"
                      src={`https://flagcdn.com/w20/${option.code.toLowerCase()}.png`}
                      srcSet={`https://flagcdn.com/w40/${option.code.toLowerCase()}.png 2x`}
                      alt=""
                    />
                    {option.label} ({option.code})
                  </Box>
                )}
                renderInput={(params) => (
                  <Box>
                    <TextField
                      {...params}
                      label="Country"
                      size="small"
                      variant="standard"
                      margin="dense"
                      fullWidth
                      name="country"
                      inputProps={{
                        ...params.inputProps,
                        style: { fontSize: 16 }
                      }}
                      InputLabelProps={{
                        style: { fontSize: 14 }
                      }}
                    />
                  </Box>
                )}
                value={formik.values.country}
                isOptionEqualToValue={(option, value) => option.label === value}
                onChange={(e, value) => {
                  console.log(value);
                  formik.setFieldValue('country', value.label);
                  dispatch(caseActions.setDataUpdated(true));
                }}
              />
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="guarantorPhone"
                label="Phone#"
                name="guarantorPhone"
                autoComplete="guarantorPhone"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                autoFocus
                value={formik.values.guarantorPhone}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.guarantorPhone && Boolean(formik.errors.guarantorPhone)}
                helperText={formik.touched.guarantorPhone && formik.errors.guarantorPhone}
              />
              <Box>
                <Typography style={styles.errorText}>{st.updatecontacterror}</Typography>
              </Box>
              <TextField
                size="small"
                variant="standard"
                margin="dense"
                fullWidth
                id="guarantorEmail"
                label="Email"
                name="guarantorEmail"
                autoComplete="guarantorEmail"
                inputProps={{ style: { fontSize: 16 } }}
                InputLabelProps={{ style: { fontSize: 14 } }}
                autoFocus
                value={formik.values.guarantorEmail}
                onChange={(e) => {
                  formik.handleChange(e);
                  dispatch(caseActions.setDataUpdated(true));
                }}
                error={formik.touched.guarantorEmail && Boolean(formik.errors.guarantorEmail)}
                helperText={formik.touched.guarantorEmail && formik.errors.guarantorEmail}
              />
              <Box>
                <Typography style={styles.errorText}>{st.updatecontacterror}</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ color: '#021D4E', width: 900, mt: 5 }}>Most Recent Insurance Cards</Divider>
        <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
          <Typography
            style={{
              color: '#021D4E',
              fontWeight: '800',
              fontSize: 12,
              mt: 0,
              mb: 5
              // textAlign: 'center'
            }}>
            Only image files (e.g. PNG, BMP, JPEG, JPG, GIF) are allowed. Maximum file size is 4MB.
          </Typography>
        </Box>
        <Grid container spacing={2}>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                border: 0,
                mt: 4,
                width: 400
              }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '800',
                    fontSize: 14,
                    textAlign: 'center'
                  }}>
                  Primary Insurance Card Front
                </Typography>
                <IconButton aria-label="delete">
                  <DeleteIcon />
                </IconButton>
              </Box>
              <a href="insuranceCardFront.png">
                <Box
                  component="img"
                  src={require('../../../images/insuranceCardFront.png')}
                  style={{ width: 400, height: 250 }}
                />
              </a>
              {false && (
                <DropzoneArea
                  acceptedFiles={['image/*']}
                  dropzoneText={
                    <Box>
                      <Typography
                        style={{
                          color: '#021D4E',
                          fontWeight: '500',
                          fontSize: 14,
                          textAlign: 'center'
                        }}>
                        Add front image of insurance card
                      </Typography>
                      <Typography
                        style={{
                          color: '#021D4E',
                          fontWeight: '800',
                          fontSize: 12,
                          textAlign: 'center'
                        }}>
                        drag & drop here or select from computer...
                      </Typography>
                    </Box>
                  }
                  onChange={(files) => console.log('Files:', files)}
                  filesLimit={1}
                  showFileNames={true}
                  showPreviews={false}
                  showPreviewsInDropzone={true}
                  maxFileSize={4000000}
                />
              )}
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={6}
            lg={6}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'flex-start',
                alignItems: 'center',
                border: 0,
                mt: 4,
                width: 400
              }}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  alignItems: 'center'
                }}>
                <Typography
                  style={{
                    color: '#021D4E',
                    fontWeight: '800',
                    fontSize: 14,
                    textAlign: 'center'
                  }}>
                  Primary Insurance Card Back
                </Typography>
                <AddIcon color="#003087" style={{ fontSize: 36, mt: 1 }} />
              </Box>
              <DropzoneArea
                fullWidth
                acceptedFiles={['image/*']}
                dropzoneText={
                  <Typography
                    style={{
                      color: '#021D4E',
                      fontWeight: '800',
                      fontSize: 12,
                      textAlign: 'center'
                    }}>
                    drag & drop here or select from computer...
                  </Typography>
                }
                onChange={(files) => console.log('Files:', files)}
                filesLimit={1}
                showFileNames={true}
                showPreviews={false}
                showPreviewsInDropzone={true}
                maxFileSize={4000000}
              />
            </Box>
          </Grid>
          <Grid
            container
            item
            xs={12}
            md={12}
            lg={12}
            direction="column"
            sx={styles.blockContainerStyle}>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'space-between',
                mt: 5,
                border: 0,
                width: 600
              }}>
              <Dialog
                open={showDialog}
                onClose={handleCancel}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">{'Save data?'}</DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    You are about to leave the form and the form contain unsaved data. Do you want
                    to save?
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleCancel}>No</Button>
                  <Button
                    onClick={() => {
                      // reset flag
                      dispatch(caseActions.setDataUpdated(false));
                      // reset fromMenu
                      // setFromMenu(false);
                      setShowDialog(false);
                      //submitCaseContactInfo(formik.values);
                      dispatch(caseActions.setViewSummary(true));
                    }}
                    autoFocus>
                    Yes
                  </Button>
                </DialogActions>
              </Dialog>
              <Button size="large" variant="contained" sx={{ mb: 5 }} onClick={handleHome}>
                <KeyboardArrowLeft />
                Home
              </Button>
              <Button size="large" variant="contained" onClick={formik.handleSubmit} sx={{ mb: 5 }}>
                Save
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
};

export default InsuranceInfo;
